import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useParams, useNavigate, Link } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_salescrap = () => {
useAuthRedirect();
  const navigate = useNavigate();
 const canEntry = hasPermission("For sale-and-scrap", "entry");
  
  
   const [selectedType, setSelectedType] = useState("");
   const myBranch = localStorage.getItem("branch");
   const userId = localStorage.getItem("username");
  const [formData, setFormData] = useState({
    branch: myBranch,
      remark: "",
      party: "",
      broker: "",
      soldPrice: "",
      soldBy: "",
      approvedBy: ""
    });
  

    const { sno } = useParams();

   const [sale, setSale] = useState({});

    

  
    useEffect(() => {
        const fetchTransfer = async () => {
          if (!sno) return;
          try {
            const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/sale_fetch?sno=${sno}`);
            if (response.data && response.data.sale?.length > 0) {
                const items = response.data.sale;
                console.log();
                

                const transferDetail = {
                    vcode: items[0].vehicle_code || "N/A",
                    vnumber: items[0].vehicle_number || "N/A",
                    vname: items[0].vehicle_name || "N/A",
                    fromBranch: items[0].branch_code || "N/A",
                    vtype: items[0].vehicle_type || "N/A",
                };

                setSale(transferDetail);
                console.log("Updated Header Details:", transferDetail);
            } else {
                console.warn("API Response does not contain expected data structure");
            }
            
            
          } catch (error) {
            console.error("Error fetching locations:", error);
          }
        };
    
        fetchTransfer();
      }, [sno]); 
  
      const handleTypeChange = (e) => {
        setSelectedType(e.target.value);
      };

   


 // Handle input change for form fields
 const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prevData) => ({
    ...prevData,
    [name]: value,
  }));
};


const handleSubmit = async (e) => {
    e.preventDefault();

     if (!selectedType.trim()) {
          Swal.fire({
            icon: 'warning',
            title: 'Empty Field',
            text: 'Please Select Sale or Scrap!',
          });
          return;
        }

        if(selectedType === 'sale') {
          if (!formData.soldBy.trim()) {
          Swal.fire({
            icon: 'warning',
            title: 'Empty Field',
            text: 'Please Enter Who Sold!',
          });
          return;
        }

        if (!formData.approvedBy.trim()) {
          Swal.fire({
            icon: 'warning',
            title: 'Empty Field',
            text: 'Please Enter Who Approve!',
          });
          return;
        }

        if (!formData.soldPrice.trim() || isNaN(formData.soldPrice)) {
  Swal.fire({
    icon: 'warning',
    title: 'Invalid Input',
    text: 'Please enter a valid numeric Sold Price!',
  });
  return;
}


        if (!formData.party.trim()) {
          Swal.fire({
            icon: 'warning',
            title: 'Empty Field',
            text: 'Please Enter Party Name!',
          });
          return;
        }

        if (!formData.broker.trim()) {
          Swal.fire({
            icon: 'warning',
            title: 'Empty Field',
            text: 'Please Enter Broker Name!',
          });
          return;
        }
        } else {
           if (!formData.soldBy.trim()) {
          Swal.fire({
            icon: 'warning',
            title: 'Empty Field',
            text: 'Please Enter Who Scraped!',
          });
          return;
        }

         if (!formData.approvedBy.trim()) {
          Swal.fire({
            icon: 'warning',
            title: 'Empty Field',
            text: 'Please Enter Who Approved!',
          });
          return;
        }

         if (!formData.remark.trim()) {
          Swal.fire({
            icon: 'warning',
            title: 'Empty Field',
            text: 'Please Enter your Remarks!',
          });
          return;
        }
        }
  
    const payload = {
      branch: myBranch,
      vcode: sale.vcode,
      user: userId,
      selected: selectedType,
      saleFrom: sale.fromBranch,
      remarks: formData.remark,
      party: formData.party,
      broker: formData.broker,
      soldPrice: formData.soldPrice,
      soldBy: formData.soldBy,
      approvedBy: formData.approvedBy,
    };
  
    console.log("Submitting Payload:", payload);
  
    // Show confirmation alert before submission
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to proceed with selling/scrapping this vehicle?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, proceed!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
           Swal.fire({
                title: "Submitting...",
                text: "Please wait while we process your request.",
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

          const response = await axios.post("https://rfs2.infraconsoft.net.in/api/sale_scrap_insert", payload);
  
          if (!response.data.success) {
            Swal.fire({
              title: "Already Sold/Scrapped",
              text: response.data.message,
              icon: "error",
            });
            return;
          }

          Swal.fire({
            title: "Success!",
            text: response.data.message || "Vehicle Sold/Scrapped successfully.",
            icon: "success",
            width: "500px",
            height: "40vh",
            draggable: true,
          }).then(() => {
            navigate("/vehicle_sale_and_scrap");
          });
  
        } catch (error) {
          console.error("Error submitting form:", error);
          Swal.fire({
            title: "Error!",
            text: error.response?.data?.message || "Submission failed. Please try again.",
            icon: "error",
          });
        }
      }
    });
  };
  
if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
           <div className="back-div">
            <h2 className="add-txt">Vehicle Sale and Scrap</h2>
            <Link to={`/vehicle_sale_and_scrap`}><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
            </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container" >
      <form className="vehicle-form" onSubmit={handleSubmit}>
      <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input type="text" name="refNo" value={sale.vcode} onChange={handleChange} readOnly />
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="date" name="endhrs"  value={new Date().toISOString().split('T')[0]}  readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Name :</label>
                <input type="text" name="refNo" value={sale.vname} onChange={handleChange} readOnly />
              </div>
              <div className="form-group">
                <label>Vehicle Number :</label>
                <input type="text" name="refNo" value={sale.vnumber} onChange={handleChange}readOnly  />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Type :</label>
                <input type="text" name="refNo" value={sale.vtype} onChange={handleChange}readOnly  />
              </div>
              <div className="form-group">
                <label>Sold/Scrap From Branch: </label>
                <input type="text" name="refNo" value={sale.fromBranch} onChange={handleChange}  readOnly/>
              </div>
            </div>

        <div className="form-row">
          <div className="form-group">
            <label>Sold or Scrap :</label>
            <select value={selectedType} onChange={handleTypeChange}>
              <option value="">-- Select an Option --</option>
              <option value="sale">Sale the vehicle</option>
              <option value="scrap">Scrap the vehicle</option>
            </select>
          </div>
          <div className="form-group">
            <label></label>
            
          </div>
        </div>

        {/* Supplier fields */}
        {selectedType === "sale" && (
            <>
           <div className="form-row">
           <div className="form-group">
             <label>Sold by :</label>
             <input type="text" name="soldBy" value={formData.soldBy} onChange={handleChange}  />
           </div>
           <div className="form-group">
             <label>Approvd By : </label>
             <input type="text" name="approvedBy" value={formData.approvedBy} onChange={handleChange}  />
           </div>
         </div>

<div className="form-row">
<div className="form-group">
  <label>Sold Price :</label>
  <input type="text" name="soldPrice" value={formData.soldPrice} onChange={handleChange}  />
</div>
<div className="form-group">
  <label>Party Name : </label>
  <input type="text" name="party" value={formData.party} onChange={handleChange}  />
</div>
</div>

<div className="form-row">
<div className="form-group">
  <label>Broker Name  :</label>
  <input type="text" name="broker" value={formData.broker} onChange={handleChange}  />
</div>
<div className="form-group">
  <label></label>
  <input type="hidden"  />
</div>
</div>

</>
        )}

        {/* Branch fields */}
        {selectedType === "scrap" && (
          <>
            <div className="form-row">
              <div className="form-group">
                <label>Scrap By :</label>
                <input type="text" name="soldBy" value={formData.soldBy}  onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Approved By :</label>
                <input type="text" name="approvedBy" value={formData.approvedBy} onChange={handleChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remark :</label>
                <input type="text" name="remark" value={formData.remark} onChange={handleChange}  />
              </div>
              <div className="form-group">
                <label></label>
                <input type="hidden"  />
              </div>
            </div>
          </>
        )}
      
            <div className="btn-cls">
          <button type="submit" className="submit-btn">Submit</button>
        </div>
      </form>
    </div>
      </div>
    </div>
  );
};

export default Vehicle_salescrap;